import React, { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';

import { ROLE, BASEURL } from '../constant';
import postApi from '../api/postApi';
import getApi from '../api/getApi';
import { getAuthBodyMessage } from '../api/userFacingError';

type AdminUser = {
  id: number;
  user: string;
  email: string;
  role: string;
};

export default function UserRegistration() {
  const [fname, setFname] = useState('');
  const [lname, setLname] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [cpassword, setCPassword] = useState('');
  const [role, setRole] = useState('');
  const [apiResMessage, setApiResMessage] = useState('');

  const [users, setUsers] = useState<AdminUser[]>([]);
  const [resetUserId, setResetUserId] = useState('');
  const [resetPassword, setResetPassword] = useState('');
  const [resetConfirm, setResetConfirm] = useState('');
  const [resetMessage, setResetMessage] = useState('');
  const [resetError, setResetError] = useState('');

  const changeRole = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const val = e.target.value;
    if (val) {
      setRole(val);
    }
  };

  const resetForm = () => {
    setFname('');
    setLname('');
    setPassword('');
    setCPassword('');
    setRole('');
    setEmail('');
  };

  const loadUsers = async () => {
    try {
      const res = await getApi(`${BASEURL}/admin/users`);
      if (res?.data) {
        setUsers(res.data);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    loadUsers();
  }, []);

  const handleSubmit = async () => {
    const payload = {
      firstname: fname,
      lastname: lname,
      password: password,
      email: email.toLowerCase(),
      role: role,
    };
    const res = await postApi(`${BASEURL}/registration`, payload);
    if (res) {
      if(res.status >= 200 && res.status < 300){
        setApiResMessage(res.data.message);
        loadUsers();
      }else{
        console.log(res);
      }
    } else {
      console.log(res);
    }
    resetForm();
  };

  const handleAdminReset = async () => {
    setResetError('');
    setResetMessage('');
    if (!resetUserId) {
      setResetError('Please select a user');
      return;
    }
    if (!resetPassword || resetPassword !== resetConfirm) {
      setResetError('Passwords must match and not be empty');
      return;
    }
    if (resetPassword.length < 8) {
      setResetError('Password must be at least 8 characters');
      return;
    }
    try {
      const res = await postApi(`${BASEURL}/admin/reset_password`, {
        user_id: Number(resetUserId),
        new_password: resetPassword,
      });
      if (res?.data?.status_code === 200) {
        setResetMessage(res.data.message || 'Password reset successfully');
        setResetPassword('');
        setResetConfirm('');
        setResetUserId('');
      } else {
        setResetError(getAuthBodyMessage(res?.data) || 'Reset failed');
      }
    } catch (err: any) {
      setResetError(err.message || 'Request failed — try again');
    }
  };

  return (
    <div className="row admin-page">
      <div className="col-12 registration-text">
        <h2>User Registration Page</h2>
      </div>
      <div className="row">
        <div className="col-3">

        </div>
        <div className="col-6">
          <div className="row form-group">
            <label>First Name</label>
            <input
              type="text"
              className="form-control"
              id="fname"
              value={fname}
              name="firstname"
              aria-describedby="fname"
              placeholder="Enter First Name"
              onChange={(event) => setFname(event.target.value)}
            />
          </div>
          <div className="row form-group">
            <label>Last Name</label>
            <input
              type="text"
              className="form-control"
              id="lname"
              value={lname}
              name="lastname"
              aria-describedby="lname"
              placeholder="Enter Last Name"
              onChange={(event) => setLname(event.target.value)}
            />
          </div>
          <div className="row form-group">
            <label>Role</label>
            <Form.Select
              aria-label="Default select example"
              onChange={(e) => changeRole(e)}
            >
              <option value="" key="99">
                Please select role
              </option>
              {ROLE.map((role, ind) => {
                return (
                  <option value={role} key={ind}>
                    {role}
                  </option>
                );
              })}
            </Form.Select>
          </div>
          <div className="row form-group">
            <label>Email</label>
            <input
              type="email"
              className="form-control"
              id="email"
              name="emailid"
              value={email}
              aria-describedby="email"
              placeholder="Enter Email"
              onChange={(event) => setEmail(event.target.value)}
            />
          </div>
          <div className="row form-group">
            <label>Password</label>
            <input
              type="password"
              className={`form-control ${
                password && cpassword && password !== cpassword
                  ? 'password-not-match'
                  : ''
              }`}
              id="exampleInputPassword1"
              value={password}
              placeholder="Password"
              onChange={(event) => setPassword(event.target.value)}
            />
          </div>
          <div className="row form-group">
            <label>Confirm Password</label>
            <input
              type="password"
              className={`form-control ${
                password && cpassword && password !== cpassword
                  ? 'password-not-match'
                  : ''
              }`}
              id="exampleInputPassword2"
              value={cpassword}
              placeholder="Confirm Password"
              onChange={(event) => setCPassword(event.target.value)}
            />
          </div>
          <div className="row submit">
            <button
              type="submit"
              className="btn-custom-primary"
              onClick={(e) => handleSubmit()}
              disabled={
                fname === '' ||
                lname === '' ||
                email === '' ||
                password === '' ||
                cpassword === '' ||
                password !== cpassword ||
                role === ''
              }
            >
              Submit
            </button>
            <small id="apiError" className="text-success form-text">
              {apiResMessage}
            </small>
          </div>

          <hr className="my-4" />
          <h4>Reset User Password</h4>
          <p className="text-muted">Admin can set a new password for any user.</p>
          <div className="row form-group">
            <label>User</label>
            <Form.Select
              value={resetUserId}
              onChange={(e) => setResetUserId(e.target.value)}
            >
              <option value="">Select user</option>
              {users.map((u) => (
                <option key={u.id} value={u.id}>
                  {u.user} ({u.email}) — {u.role}
                </option>
              ))}
            </Form.Select>
          </div>
          <div className="row form-group">
            <label>New Password</label>
            <input
              type="password"
              className="form-control"
              value={resetPassword}
              placeholder="At least 8 characters"
              onChange={(e) => setResetPassword(e.target.value)}
            />
          </div>
          <div className="row form-group">
            <label>Confirm New Password</label>
            <input
              type="password"
              className="form-control"
              value={resetConfirm}
              placeholder="Confirm password"
              onChange={(e) => setResetConfirm(e.target.value)}
            />
          </div>
          <div className="row submit">
            <button
              type="button"
              className="btn-custom-primary"
              onClick={handleAdminReset}
            >
              Reset Password
            </button>
            {resetMessage && (
              <small className="text-success form-text">{resetMessage}</small>
            )}
            {resetError && (
              <small className="text-danger form-text">{resetError}</small>
            )}
          </div>
        </div>
        <div className="col-3"></div>
      </div>
    </div>
  );
}
